/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class MathModule {
  // Clamp: Ensure the value submitted is inside a range. Set to min if less, max if more
  static clamp(value: number, minimum: number, maximum: number): number {
    return (value < minimum) ? minimum : (value > maximum) ? maximum : value;
  }

}
